export function initializeRichText() {
  // wadd css class to any image inside a link tag.
  function imageLinks() {
    if (document.querySelector('.rich-text')) {
      const richtext = document.querySelector('.rich-text');
      const linkImages = richtext.querySelectorAll('a > img');

      [...linkImages].forEach((linkImage) => {
        linkImage.parentElement.classList.add('has-image');
      });
    }
  }

  // open all PDF's in a new tab
  function pdfLinks() {
    const linkPdfs = document.querySelectorAll('a[href*="pdf"]');

    [...linkPdfs].forEach((linkPdf) => {
      linkPdf.setAttribute('target', '_blank');
    });
  }

  imageLinks();
  pdfLinks();
}
